import { get } from 'lodash';
import { createSelector } from 'reselect';
import moment from 'moment';
import _ from 'lodash';

import { AvailableKitchenPrepWorksheetEnum } from 'Common/FieldEnum';
import { SiteTypeEnum } from 'Common/Constants/Enumeration/SiteTypeEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

const root = state =>
  get(state, 'KitchenPrepWorksheetState.availableKitchenPrepWorksheetState');

export const getKitchenListData = state =>
  get(root(state), 'kitchenListData', []);
export const getKitchenListLoading = state =>
  get(root(state), 'kitchenListLoading', false);
export const getKitchenListLoadingError = state =>
  get(root(state), 'kitchenListLoadingError', null);
export const getAvailableKitchenDataLoading = state =>
  get(root(state), 'availableKitchenDataLoading', false);
export const getAvailableKitchenData = state =>
  get(root(state), 'availableKitchenData', []);
export const getAvailableKitchenDataError = state =>
  get(root(state), 'availableKitchenDataError', null);
export const getFromDateMax = state => get(root(state), 'fromDateMax', null);
export const getToDateMin = state => get(root(state), 'toDateMin', null);

export const getAvailableKitchenFormattedData = createSelector(
  getAvailableKitchenData,
  result =>
    result.map(item => ({
      ...item,
      [AvailableKitchenPrepWorksheetEnum.DeliveryDate]: item[
        AvailableKitchenPrepWorksheetEnum.DeliveryDate
      ]
        ? moment(item[AvailableKitchenPrepWorksheetEnum.DeliveryDate]).format(
            DATE_FORMAT_FOR_UI
          )
        : '',
    }))
);

export const getKitchenListFilteredData = createSelector(
  getKitchenListData,
  result =>
    _.filter(result, [
      AvailableKitchenPrepWorksheetEnum.SiteMasterTypeId,
      SiteTypeEnum.Kitchen,
    ])
);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/availableKitchenPrepWorksheet/selectors.js